// react
import React, { useState } from 'react';

// third-party
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

// application
import PageHeader from '../shared/PageHeader';
import theme from '../../data/theme';
import { postLogin } from '../../store/auth/authActions';

export default function AccountPageLogin() {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const breadcrumb = [
    { title: 'Home', url: '/' },
    { title: 'Akun', url: '/account' },
    { title: 'Login', url: '' },
  ];

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const login = (e) => {
    e.preventDefault();
    if (!usernameOrEmail.trim() || !password) {
      toast.error('Email atau username dan kata sandi wajib diisi!');
      return;
    }
    const body = {
      usernameOrEmail: usernameOrEmail.trim(),
      password,
    };
    dispatch(postLogin(body));
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>{`Masuk Akun | ${theme.name}`}</title>
      </Helmet>

      <div className="hokky-auth-page-block">
        <PageHeader breadcrumb={breadcrumb} />
        <div className="container hokky-auth-main-container">
          <div className="hokky-auth-container">
            <div className="hokky-auth-card">
              <div className="hokky-auth-header">
                <img
                  src={`${process.env.PUBLIC_URL || ''}/images/logo-footer.png`}
                  alt="Hokky Bangunan"
                  className="auth-brand-logo"
                />
                <h2 className="auth-title">Masuk ke Akun</h2>
              </div>

              <form className="hokky-auth-form" onSubmit={login}>
                <div className="auth-form-group">
                  <label htmlFor="login-email">Email atau Username</label>
                  <div className="auth-input-wrapper">
                    <i className="far fa-envelope input-icon-left" />
                    <input
                      id="login-email"
                      type="text"
                      className="auth-input"
                      placeholder="Masukkan email Anda"
                      value={usernameOrEmail}
                      onChange={(e) => setUsernameOrEmail(e.target.value)}
                      autoComplete="username"
                      required
                    />
                  </div>
                </div>

                <div className="auth-form-group">
                  <label htmlFor="login-password">Kata Sandi</label>
                  <div className="auth-input-wrapper">
                    <i className="fas fa-lock input-icon-left" />
                    <input
                      id="login-password"
                      type={showPassword ? 'text' : 'password'}
                      className="auth-input"
                      placeholder="Masukkan kata sandi Anda"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      required
                    />
                    <button
                      type="button"
                      className="auth-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={showPassword ? 'Sembunyikan sandi' : 'Tampilkan sandi'}
                    >
                      <i className={`far ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                    </button>
                  </div>
                </div>

                <div className="auth-options-row">
                  <label className="auth-remember-me" htmlFor="login-remember">
                    <input
                      id="login-remember"
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <span>Ingat Saya</span>
                  </label>
                  <Link to="/account/forgot" className="auth-forgot-link">
                    Lupa Kata Sandi?
                  </Link>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="btn-auth-submit"
                >
                  {loading ? (
                    <i className="fas fa-spinner fa-spin" />
                  ) : (
                    'Masuk Sekarang'
                  )}
                </button>

                <div className="auth-divider">
                  <span>atau</span>
                </div>

                <p className="auth-footer-prompt">
                  Belum memiliki akun?
                  <Link to="/account/sign-up" className="auth-link-bold">
                    Buat Akun Baru
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
